<template>
<v-app id="inspire">

    <v-app-bar
      app
      color="white"
      flat
    >
      <v-container class="py-0 fill-height">

        <v-btn
          @click="tomember"
        >
          member
        </v-btn>

        <v-spacer></v-spacer>
        <p >疾病名：</p>
        <v-responsive max-width="260">
          <v-text-field
            v-model="message"
            dense
            flat
            hide-details
            rounded
            solo-inverted
          ></v-text-field>
        </v-responsive>
      </v-container>
    </v-app-bar>

    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <v-col cols="2">
            <v-sheet rounded="lg">
              <v-list color="transparent">
                <v-list-item
                  v-for="n in 5"
                  :key="n"
                  link
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      疾病 {{ n }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider class="my-2"></v-divider>

              </v-list>
            </v-sheet>
          </v-col>

          <v-col>
            <v-sheet
              min-height="70vh"
              rounded="lg"
            >
            
              <div class="resault" v-for="data in searchWithTrie(this.$route.params.input, geojsonData)" :key="data.title">
                 <a
                    target="_blank"
                    :href="'https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=' + data.gseid" 
                    >
                    
                    <span class="resault">{{ data.title }}</span>
                    </a>  
                </div>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld';
// import JsonViewer from 'vue-json-viewer'
import geo from '../data/GEO_papers.json'
import omim from '../data/OMIM_intro.json'

export default {
  name:'Vue',
  components: {
    //JsonViewer
  },

  data(){
    return {
      geojsonData:geo,
      ominjsonData:omim,
      message:this.$route.params.input,
    }
  },
  //搜索功能待定
  methods:{
    tomember:function(){
      this.$router.push({
        path:'/member'
      })
    },
    buildTrie(arr) {
      const trie = {};
      arr.forEach(word => {
        let current = trie;
        for (let i = 0; i < word.length; i++) {
          const char = word[i];
          if (!current[char]) {
            current[char] = {};
          }
          current = current[char];
        }
        current.isWord = true;
      });
      return trie;
    },

    matchTrie(trie, word) {
      let current = trie;
      for (let i = 0; i < word.length; i++) {
        const char = word[i];
        if (!current[char]) {
          return false;
        }
        current = current[char];
      }
      return current.isWord;
    },


    search(query, data){
      // turn the query into lowercase
      query = query.toLowerCase();
      // split the query into words
      var queryWords = query.split(/\s+/g);
      // each item in the data has a title and description
      // use the map function to search the titles for the query words
      // count the number of matches for each item
      // filter the items that have a match count greater than 0
      // save the match count and the item to an object
      // then sort the items by the match count
      // return the items in the array
      return data.map(function(item){
        var matchCount = 0;
        queryWords.forEach(function(queryWord){
          if(item.title.toLowerCase().indexOf(queryWord) > -1){
            matchCount++;
          }
        });
        if(matchCount > 0){
          return {
            matchCount:matchCount,
            item:item
          };
        }
      }).filter(function(item){
        return item !== undefined;
      }).sort(function(a, b){
        return b.matchCount - a.matchCount;
      }).map(function(item){
        return item.item;
      });
    },


    searchWithTrie(query, data) {
      // turn the query into lowercase
      query = query.toLowerCase();
      // split the query into words
      var queryWords = query.split(/\s+/g);
      // create a trie to store the words
      var trie = this.buildTrie(queryWords);
      // each item in the data has a title and description
      // iterate through the items for the title
      // split the title into words
      // check if the word is in the trie
      // count the number of matches for each word
      // filter the items that have a match count greater than 0
      // save the match count and the item to an object
      // then sort the items by the match count
      // return the items in the array
      var match = this.matchTrie;
      return data.map(function(item){
        var matchCount = 0;
        item.title.toLowerCase().split(/\s+/g).forEach(function(titleWord){
          if(match(trie, titleWord)){
            matchCount++;
          }
        });
        if(matchCount > 0){
          return {
            matchCount:matchCount,
            item:item
          };
        }
      }).filter(function(item){
        return item !== undefined;
      }).sort(function(a, b){
        return b.matchCount - a.matchCount;
      }).map(function(item){
        return item.item;
      });
    }
  }
}
</script>

<style>
  .q-search{
    margin-top: 5vh;
    margin-left: 20vw;
  }
  .search{
    margin-top: 5vh;
    margin-left: 3vw;
  }
  .resault{
    margin-top: 5vh;
    margin-left: 2vw;
    margin-right: 2vw;
  }
</style>
